// extracted by mini-css-extract-plugin
export default {"card":"Projects_card__AAoVy","container":"Projects_container__MaVS7"};